import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import * as tokens from 'styles';

type DentGroupProps = {
  $right?: boolean;
  $animate: boolean;
};

const DentGroup = styled.div<DentGroupProps>`
  position: absolute;
  ${props => (props.$right ? 'right: 9px' : 'left: -6px')};
  height: 60px;
  top: calc(50% - 30px);
  & > * {
    position: absolute;
    border-radius: 15px;
    width: 15px;
    height: 15px;
    background-color: ${tokens.sunflower};
    ${props =>
      props.$animate
        ? css`
            animation-name: ${tokens.zoom};
            animation-duration: 0.25s;
            animation-timing-function: ${tokens.easingAdvanceDefault};
            animation-delay: 0.5s;
            animation-fill-mode: both;
          `
        : ''}
  }
  & > *:nth-child(1) {
    top: 0px;
  }
  & > *:nth-child(2) {
    top: 22px;
  }
  & > *:nth-child(3) {
    top: 44px;
  }
`;

const TicketSection = styled.section`
  & {
    background: ${tokens.royalBlue};
    color: ${tokens.white};
    box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.1);
    padding: ${tokens.spacer32};
    text-align: center;
    position: relative;
    margin: 0 auto ${tokens.spacer24} auto;
  }
  & svg {
    fill: ${tokens.white};
  }
`;

type TicketProps = {
  children: ReactNode;
  animateDents?: boolean;
};

const Ticket = ({ children, animateDents = false }: TicketProps) => (
  <TicketSection>
    <DentGroup $animate={animateDents}>
      <div />
      <div />
      <div />
    </DentGroup>
    {children}
    <DentGroup $right $animate={animateDents}>
      <div />
      <div />
      <div />
    </DentGroup>
  </TicketSection>
);

export default Ticket;
